import { render, staticRenderFns } from "./forgetPayPsw.vue?vue&type=template&id=49d7a6a5&scoped=true&"
import script from "./forgetPayPsw.vue?vue&type=script&lang=js&"
export * from "./forgetPayPsw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d7a6a5",
  null
  
)

export default component.exports